export default {
  DEFAULT_SCALE: 1.0,
  CSS_UNITS: 96.0 / 72.0,
  ENHANCE_TEXT_SELECTION: true,
  USE_TEXT_LAYER: true,
  TEXT_LAYER_RENDER_DELAY: 200,
  DEFAULT_CACHE_SIZE: 10,
  cleanupTimeout: 1000,
  pageScrollMargin: -85,
};
